export default "__VITE_ASSET__Do82QMa1__"